export default {
  name: 'pc-carousel',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '轮播图',
          icon: 'el-icon-picture',
          content: {
            indicator: false,
            list: [{
              label: '',
              img: '',
              link: {}
            }]
          },
          config: [{
            label: '是否开启扩展',
            hint: '开启扩展后会显示标题与富文本内容同步切换',
            type: 'switch',
            name: 'switch'
          }, {
            label: '是否隐藏指示器',
            type: 'switch',
            name: 'indicator'
          }, {
            label: '是否自动切换',
            type: 'switch',
            name: 'autoplay'
          }, {
            label: '切换间隔',
            type: 'number',
            name: 'interval'
          }, {
            label: '轮播图配置',
            name: 'list',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              richText: {
                label: '额外内容',
                value: 'html'
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      data: {},
      thatIndex: 0
    };
  },
  watch: {
    widgets: {
      handler: function handler(val) {
        if (val) {
          var _val$content;
          this.data = (val === null || val === void 0 || (_val$content = val.content) === null || _val$content === void 0 ? void 0 : _val$content.list[0]) || {};
        }
      },
      immediate: true
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};